import { CONEXAO_ONLINE, CONEXAO_OFFLINE } from '../../actions/util/conexaoActions'

const initialState = { online: typeof navigator !== 'undefined' ? navigator.onLine : true }

export default function (state = initialState, action) {
  switch (action.type) {
    case CONEXAO_ONLINE:
      return { online: true }
    case CONEXAO_OFFLINE:
      return { online: false }
    default:
      return state
  }
}
